import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Overview
  overview: null,
  overviewLoading: false,
  overviewError: null,

  // Teacher breakdown
  teachers: [],
  teachersLoading: false,
  teachersError: null,

  // Teacher detail (drill-down)
  teacherDetail: null,
  teacherDetailLoading: false,
  teacherDetailError: null,

  // Analytics: Class performance
  classPerformance: { viewMode: 'byGrade', data: [], teachers: [] },
  classPerformanceLoading: false,
  classPerformanceError: null,

  // Analytics: Subject breakdown
  subjectBreakdown: [],
  subjectBreakdownLoading: false,
  subjectBreakdownError: null,

  // Analytics: Teacher activity
  teacherActivity: [],
  teacherActivityLoading: false,
  teacherActivityError: null,

  // Filters
  filters: {
    period: null,
    startDate: null,
    endDate: null,
    subject: null,
    grade: null,
    category: null
  }
};

const principalDashboardSlice = createSlice({
  name: 'principalDashboard',
  initialState,
  reducers: {
    // Overview
    setOverviewLoading: (state) => {
      state.overviewLoading = true;
      state.overviewError = null;
    },
    setOverviewSuccess: (state, action) => {
      state.overview = action.payload;
      state.overviewLoading = false;
      state.overviewError = null;
    },
    setOverviewError: (state, action) => {
      state.overviewLoading = false;
      state.overviewError = action.payload;
    },

    // Teachers
    setTeachersLoading: (state) => {
      state.teachersLoading = true;
      state.teachersError = null;
    },
    setTeachersSuccess: (state, action) => {
      state.teachers = action.payload;
      state.teachersLoading = false;
      state.teachersError = null;
    },
    setTeachersError: (state, action) => {
      state.teachersLoading = false;
      state.teachersError = action.payload;
    },

    // Teacher detail
    setTeacherDetailLoading: (state) => {
      state.teacherDetailLoading = true;
      state.teacherDetailError = null;
    },
    setTeacherDetailSuccess: (state, action) => {
      state.teacherDetail = action.payload;
      state.teacherDetailLoading = false;
      state.teacherDetailError = null;
    },
    setTeacherDetailError: (state, action) => {
      state.teacherDetailLoading = false;
      state.teacherDetailError = action.payload;
    },
    clearTeacherDetail: (state) => {
      state.teacherDetail = null;
      state.teacherDetailLoading = false;
      state.teacherDetailError = null;
    },

    // Class performance
    setClassPerformanceLoading: (state) => {
      state.classPerformanceLoading = true;
      state.classPerformanceError = null;
    },
    setClassPerformanceSuccess: (state, action) => {
      state.classPerformance = action.payload;
      state.classPerformanceLoading = false;
      state.classPerformanceError = null;
    },
    setClassPerformanceError: (state, action) => {
      state.classPerformanceLoading = false;
      state.classPerformanceError = action.payload;
    },

    // Subject breakdown
    setSubjectBreakdownLoading: (state) => {
      state.subjectBreakdownLoading = true;
      state.subjectBreakdownError = null;
    },
    setSubjectBreakdownSuccess: (state, action) => {
      state.subjectBreakdown = action.payload;
      state.subjectBreakdownLoading = false;
      state.subjectBreakdownError = null;
    },
    setSubjectBreakdownError: (state, action) => {
      state.subjectBreakdownLoading = false;
      state.subjectBreakdownError = action.payload;
    },

    // Teacher activity
    setTeacherActivityLoading: (state) => {
      state.teacherActivityLoading = true;
      state.teacherActivityError = null;
    },
    setTeacherActivitySuccess: (state, action) => {
      state.teacherActivity = action.payload;
      state.teacherActivityLoading = false;
      state.teacherActivityError = null;
    },
    setTeacherActivityError: (state, action) => {
      state.teacherActivityLoading = false;
      state.teacherActivityError = action.payload;
    },

    // Filters
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },

    // Reset all
    resetPrincipalDashboard: () => initialState
  }
});

export const {
  setOverviewLoading, setOverviewSuccess, setOverviewError,
  setTeachersLoading, setTeachersSuccess, setTeachersError,
  setTeacherDetailLoading, setTeacherDetailSuccess, setTeacherDetailError, clearTeacherDetail,
  setClassPerformanceLoading, setClassPerformanceSuccess, setClassPerformanceError,
  setSubjectBreakdownLoading, setSubjectBreakdownSuccess, setSubjectBreakdownError,
  setTeacherActivityLoading, setTeacherActivitySuccess, setTeacherActivityError,
  setFilters, clearFilters,
  resetPrincipalDashboard
} = principalDashboardSlice.actions;

export default principalDashboardSlice.reducer;
